import type { LandingQuickStart } from "@/types";

const demoSession = "/assessments/sess_demo_001";

export const mockLandingQuickStarts: LandingQuickStart[] = [
  {
    id: "quarterly-review",
    title: "Quarterly Review",
    description:
      "Roll up spend, commitments, and unit economics for leadership with a consistent quarterly narrative.",
    href: `${demoSession}?preset=quarterly-review`,
    prompt: "I need to do a Quarterly Review. Roll up spend, commitments, and unit economics for leadership with a consistent quarterly narrative.",
  },
  {
    id: "spend-spike",
    title: "Investigate Spend Spike",
    description:
      "Trace a cost increase to services, regions, or changes so you can respond with evidence, not guesses.",
    href: `${demoSession}?preset=spend-spike`,
    prompt: "I want to investigate a spend spike. Trace a cost increase to services, regions, or changes so I can respond with evidence.",
  },
  {
    id: "budget-risk",
    title: "Budget Risk Check",
    description:
      "Compare forecast to budget, surface variance drivers, and flag risk before period close.",
    href: `${demoSession}?preset=budget-risk`,
    prompt: "I need a budget risk check. Compare my forecast to budget, surface variance drivers, and flag any risks before period close.",
  },
  {
    id: "architecture-cost",
    title: "Architecture Cost Review",
    description:
      "Connect workloads and architecture choices to recurring cost so redesign options stay grounded.",
    href: `${demoSession}?preset=architecture-cost`,
    prompt: "I need an architecture cost review. Connect my workloads and architecture choices to recurring cost so any redesign options stay grounded.",
  },
];
